__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "buy-insurance-web";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@storebrand-digital/auth", "6.0.0", () => (__webpack_require__.e(8096).then(() => (() => (__webpack_require__(92026))))));
			register("react-dom", "19.2.7", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(2099)]).then(() => (() => (__webpack_require__(2163))))));
			register("react", "19.2.7", () => (__webpack_require__.e(8096).then(() => (() => (__webpack_require__(12888))))));
			register("styled-components", "6.1.8", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(2099)]).then(() => (() => (__webpack_require__(18299))))));
			register("styled-components", "6.4.3", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(2099)]).then(() => (() => (__webpack_require__(76912))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};